import { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import { getMyRank, acknowledgeRankUp } from '../services/api';
import { toast } from '../hooks/use-toast';

// Bureau-gold confetti burst from both lower corners.
const fireConfetti = () => {
  const colors = ['#FCD34D', '#D97706', '#FDE68A', '#E0E3E8', '#FFFFFF'];
  const shoot = (originX, angle) =>
    confetti({
      particleCount: 70,
      spread: 62,
      startVelocity: 55,
      angle,
      origin: { x: originX, y: 1 },
      colors,
      scalar: 1.1,
      ticks: 220,
      zIndex: 9999,
    });
  shoot(0.08, 60);
  shoot(0.92, 120);
  setTimeout(() => {
    confetti({
      particleCount: 90,
      spread: 100,
      startVelocity: 45,
      origin: { x: 0.5, y: 0.9 },
      colors,
      scalar: 1.2,
      ticks: 240,
      zIndex: 9999,
    });
  }, 220);
};

/**
 * Mounts once per authenticated user (keyed by user id in App). On first load it
 * asks the backend whether the member just crossed into a new Bureau rank; if so
 * it fires a gold confetti burst + a celebratory toast, then acknowledges it so
 * the celebration never repeats.
 */
export default function RankUpWatcher() {
  const checked = useRef(false);

  useEffect(() => {
    if (checked.current) return;
    checked.current = true;

    (async () => {
      try {
        const data = await getMyRank();
        if (!data?.rankedUp || !data?.rankedUpTo) return;
        const rank = data.rankedUpTo;
        fireConfetti();
        toast({
          title: `⭐ PROMOTED — ${(rank.rankName || '').toUpperCase()}`,
          description: `The Bureau has recognized your service. You've earned the rank of ${rank.rankName}. Check your Service Record for new rewards.`,
          duration: 9000,
        });
        await acknowledgeRankUp();
      } catch (_) {
        // silent — never block the app on a celebration check
      }
    })();
  }, []);

  return null;
}
